import { runInAction, makeAutoObservable } from 'mobx';
import Cookies from 'js-cookie';
import { getStageFromUrl } from '@insurancemenu/imenu-components-lib/dist/helpers';
import { refreshToken } from '../../api/refreshToken';
import { RootStore } from '../rootStore';

export class LoginSessionStore {
  // State
  rootStore: RootStore;
  isLoggedIn = false;
  loading = true;

  // Actions
  private setLoading(status: boolean): void {
    this.loading = status;
  }

  private setLoggedInStatus(status: boolean): void {
    this.isLoggedIn = status;
  }

  public async checkIfUserIsLoggedIn(): Promise<void> {
    this.setLoading(true);
    await this.requestRefreshTokenAsync();
    this.setLoading(false);
  }

  public async requestRefreshTokenAsync(): Promise<void> {
    try {
      const res = await refreshToken();
      runInAction(() => {
        if (res.status === 200) {
          this.logInUser();
        }
      });
    } catch (error) {
      console.error(error);
      this.logOutUser();
    }
  }

  public logOutUser(): void {
    this.setLoggedInStatus(false);
    Cookies.set(`showChangeAgencyOption_${getStageFromUrl()}`, 'false', {
      domain: process.env.REACT_APP_DOMAIN_NAME_URL,
    });
  }

  public logInUser(): void {
    this.setLoggedInStatus(true);
  }

  // Initialization
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
